module.exports = __webpack_public_path__ + "img/ownmesh-logo.bb4784b0.svg";